import React from 'react';
import ContentLoader from 'react-content-loader';

const CustomContentLoader = (props) => {
  const { staticContext, ...rest } = props;
  return <ContentLoader {...rest} />;
};

export default CustomContentLoader;